var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.PromptDialog, {
    attrs: {
      title: _vm.title,
      isOpened: _vm.isOpened,
      context: _setup.context,
      width: _vm.width,
      formSchema: _setup.formSchema,
      formFieldValues: _setup.getFormData,
      showRequiredFieldsAdvice: _vm.showRequiredFieldsAdvice,
      parentField: _setup.props.parentField,
    },
    on: {
      "execute-action": _setup.onExecuteAction,
      changeFormField: _setup.onChangeFormFieldValue,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }